import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import ConfirmTextButton from '../atoms/ConfirmTextButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openConfirm,
    updateOpenConfirm,
    cancelAction,
    confirmAction,
    monthInvoice
  }) => {
    const d = new Date(monthInvoice);
    const date = d.toLocaleString('ja-JP', { year: 'numeric', month: 'long' });
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {date}
            の請求を確定させますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ConfirmTextButton onClickAction={confirmAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
